<template>
  <div id="legal-container">
    <LazyHH4 class="mt-5 mb-4">
      Informations légales
    </LazyHH4>

    <div class="container">
      <div class="row">
        <div
          v-for="info in informations"
          :key="info.type"
          class="col-12 info"
        >
          <div class="row">
            <div class="col-7 label">
              {{ info.type }}
            </div>
            <div class="col-5 value">
              {{ info.value }} {{ info.unit }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  regulations?: Array<any>
}>()

const informations = computed(() => {
  const informations: any[] = []
  props.regulations.filter(r => r.type)?.forEach(function (regulation) {
    let info
    if (regulation.type.includes('Charges') || regulation.type.includes('Taxe')) {
      info = regulation
      info.unit = '€'
      informations.push(regulation)
    } else if (regulation.type.includes('Loi')) {
      info = regulation
      info.unit = 'm²'
      informations.push(regulation)
    }
  })
  return informations
})
</script>

<style lang="scss" scoped>
#legal-container {
  margin-bottom: 30px;
}

.info {
  border-bottom: 1px solid #CECFD6;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.row,
.label {
  padding-left: 0;
}

.info .label {
  color: $night-blue;
  font-weight: bold;
}

.info .value {
  text-align: right;
}
</style>
